module.exports = __webpack_public_path__ + "kBVzUNvI_400x400.jpg?41ee32f50f1b7127066331ec869be476";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/kBVzUNvI_400x400.jpg
// module id = 665
// module chunks = 0